import {
  DownloadStatusPayload,
  DownloadStatus
} from '@shared/SPA/UWPNotifier'
import { Milliseconds} from './formatting'

const TWODAYS = new Milliseconds().fromDays(2)
const NOEXPIRATION = 0

export const isLicenseValid = ({LicenseUsableForPlay, LicenseExpirationDate}: DownloadStatusPayload) =>
(LicenseUsableForPlay === true && (LicenseExpirationDate == NOEXPIRATION || LicenseExpirationDate > Date.now()))

export const isLicenseExpiresSoon = (props: DownloadStatusPayload) => (isLicenseValid(props) && props.LicenseExpirationDate != NOEXPIRATION && props.LicenseExpirationDate < (Date.now() + TWODAYS))

export const isShowPlayButton = (props: DownloadStatusPayload) => (props.Status === DownloadStatus.COMPLETED && (!props.NeedsLicense || (props.NeedsLicense && isLicenseValid(props))))

export const isShowModalBeforePlay = (props: DownloadStatusPayload) => (isLicenseValid(props) && !isLicenseExpiresSoon(props) && props.LicenseExpireAfterFirstPlay <= TWODAYS)